import { useTranslation } from "react-i18next";
import { Outlet, useOutletContext, useSearchParams } from "react-router";
import { SubNav } from "../components/SubNav";
import Accrual from "./leave/Accrual";
import CompOff from "./leave/CompOff";
import Policy from "./leave/Policy";
import { usePeopleCompany } from "./People";

/** Leave policy and accrual (WP-24 wave M, HRX-04), split into screens.
 *
 * Entitlement here is hand-allocated: zero leave policies, zero policy assignments, and the same 24 days of
 * annual leave for all 104 employees whatever their grade and whenever they joined. The part that hides it is
 * that every leave type carries a monthly accrual frequency while `is_earned_leave` is off on all of them, so
 * the form reads as though leave accrues and it does not. */

export const LEAVE_SCREENS = ["accrual", "compoff"] as const;

export default function Leave() {
  const { t } = useTranslation();
  const company = usePeopleCompany();
  const [params] = useSearchParams();
  const query = params.get("company") ? `?company=${encodeURIComponent(params.get("company")!)}` : "";

  const items = [
    { key: "policy", to: `/people/leave${query}`, label: t("lv.tabs.policy"), end: true },
    ...LEAVE_SCREENS.map((k) => ({ key: k, to: `/people/leave/${k}${query}`, label: t(`lv.tabs.${k}`) })),
  ];

  return (
    <div data-leave>
      <SubNav items={items} label={t("lv.sections")} />
      <Outlet context={{ company }} />
    </div>
  );
}

const useCompany = () => useOutletContext<{ company: string }>().company;

export const LeaveIndex = () => <Policy company={useCompany()} />;
export const LeaveAccrual = () => <Accrual company={useCompany()} />;
export const LeaveCompOff = () => <CompOff company={useCompany()} />;
